module.exports = __webpack_public_path__ + "img/GiftCard_template.dcd97633.jpg";